// Third Party
import { map } from "rxjs/operators";
import { ofType } from "redux-observable";

// Project
import { messageAttachmentOpenStart } from "../../../../actions/messageViewActions";
import { MESSAGE_ATTACHMENT_OPEN_REQUEST } from "../../../../constants/ActionTypes.js";

const messageAttachmentOpenRequestEpic = action$ => action$.pipe(
  ofType(MESSAGE_ATTACHMENT_OPEN_REQUEST),
  map(action => messageAttachmentOpenStart(action.mailboxAddress, action.messageIdentity,
    action.attachmentIdentifier))
);

export default messageAttachmentOpenRequestEpic;
